/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:01:07
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-24 17:10:04
 */
import req from "@/utils/request";



export const list = (params) => req.post("/site-service/m/manuscript/selectPage", params);
export const deleteById = (params) => req.post("/site-service/m/manuscript/deleteById", params);
export const offline = (params) => req.post("/site-service/m/manuscript/toColumnOffline", params);
export const selectListById = (params) => req.post("/site-service/m/journal/selectListById", params);
export const release = (params) => req.post("/site-service/m/manuscript/toColumnExamine", params);
export const up = (params) => req.post("/site-service/m/manSort/up", params);
export const down = (params) => req.post("/site-service/m/manSort/down", params);
export const previewOfflineManuscript = (params) => req.post("/front-service/m/previewOfflineManuscript", params);

export const cancelTop = (params) => req.post("/site-service/m/manSort/cancelTop", params);
export const top = (params) => req.post("/site-service/m/manSort/top", params);

export const columnManuscriptBatchCopy = (params) => req.post("/site-service/m/manuscript/columnManuscriptBatchCopy", params);
export const removeColumnManuscript = (params) => req.post("/site-service/m/manuscript/removeColumnManuscript", params);
export const ColumnDetailsDataResponse = (params) => req.post("/site-service/m/site/column/selectColumnDetails", params);
export const columnManuscriptMigrate = (params) => req.post("/site-service/m/manuscript/columnManuscriptMigrate", params);


// 以下是需要的
export const tree = (params) => req.post("/manager-service/m/organization/organTree", params);
export const unitRatingListPage = (params) => req.post("/site-service/m/push/unitRatingListPage", params);
export const scoringStatisticsCount = (params) => req.post("/site-service/m/push/scoringStatisticsCount", params);
export const selectList = (params) => req.post("/site-service/m/scoreOrgan/selectList", params);
export const selectListCreate = (params) => req.post("/site-service/m/scoreOrgan/create", params);
export const selectListUpdate = (params) => req.post("/site-service/m/organConfig/selectList", params);
export const update = (params) => req.post("/site-service/m/scoreOrgan/update", params);
export const deleteTable = (params) => req.post("/site-service/m/scoreOrgan/delete", params);
export const exportData = (params) => req.down("/site-service/m/push/export", params);